import React, { Component } from 'react';

import { isEmpty, getWeek, getDateFromDayByWeek } from '../../../Common/Common';
import Editbox from '../../../Part_Sample/Editbox';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import CalendarWithMultiDates from '../../../Part_Sample/CalendarWithMultiDates';

export default class Add_Edit_Calendar extends Component {
	constructor(props) {
		super(props);
		let calendar_name = '';
		let specified_dates = [];
		let specified_by_week = [];

		if (this.props.param.calendar_id != '') {
			let calendar = this.props.param.schedule.calendar[this.props.param.calendar_id];
			calendar_name = calendar.name;

			let dates = calendar.date;
			for (let month in dates) {
				for (let i of dates[month]) {
					let new_date = new Date();
					new_date.setHours(0, 0, 0);
					new_date.setMilliseconds(0)
					new_date.setMonth(parseInt(month) - 1); // set the month 
					new_date.setDate(i);
					specified_dates.push(new_date);
				}
			}

			let dow = calendar.dow;
			for (let month in dow) {
				for (let week in dow[month]) {
					for (let day of dow[month][week]) {
						let new_date = new Date();
						new_date.setHours(0, 0, 0);
						new_date.setMilliseconds(0);
						new_date = getDateFromDayByWeek(day, week, month - 1, new_date);
						specified_by_week.push(new_date);
					}
				}
			}
		}

		this.state = {
			calendar_name: calendar_name,
			specified_dates: specified_dates,
			specified_by_week: specified_by_week,
		}
	}

	handlePrevious = () => {
		// Tommy - 24/06/2021 - If ReiriHome, should go back to Add_Edit_Schedule_Home.js
		if (this.props.receiver.app_model == 'H') this.props.content_handler('Add_Edit_Schedule_Home', this.props.param);
		else this.props.content_handler('Schedule_Step4_Execute_Days', this.props.param);
	}

	handleChangeCalendarName = (val) => {
		this.setState({ calendar_name: val })
	}

	handleChangeDate = (specified_date, specified_by_week) => {
		this.setState({
			specified_dates: specified_date,
			specified_by_week: specified_by_week
		});
	}

	handleRegister = () => {
		if (this.state.calendar_name == '') {
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		} else if (this.state.specified_dates.length < 1 && this.state.specified_by_week.length < 1) {
			window.app.showToast(this.props.receiver.getString('no_date'), 3000);
			return;
		}

		let calendar_temp = {}
		let specified_dates = this.state.specified_dates;
		let specified_by_week = this.state.specified_by_week;

		let date = {};
		for (let i in specified_dates) {
			//"date":{month:[day],..},
			let temp_date1 = new Date(specified_dates[i])
			let month = (temp_date1.getMonth() + 1).toString();
			let new_date = temp_date1.getDate();
			if (date[month] == null) date[month] = [];
			date[month].push(new_date);
		}

		let dow = {};
		for (let j in specified_by_week) {
			//"dow":{month:{nth week:[0-6]},...}}
			let temp_date2 = new Date(specified_by_week[j]);
			let month = (temp_date2.getMonth() + 1).toString();
			let nth_week = (getWeek(temp_date2)).toString();

			if (dow[month] == null) dow[month] = {};
			if (dow[month][nth_week] == null) dow[month][nth_week] = [];
			dow[month][nth_week].push(temp_date2.getDay());
		}

		let calendar_details = {};
		calendar_details.name = this.state.calendar_name;
		calendar_details.date = date;
		calendar_details.dow = dow;

		if (this.props.param.calendar_id == '') {
			this.props.receiver.addCalendar(calendar_details);
		} else {
			let calendar = {};
			calendar[this.props.param.calendar_id] = calendar_details;
			this.props.receiver.modifyCalendar(calendar);
		}
	}

	handleDelete = () => {
		this.props.receiver.deleteCalendar(this.props.param.calendar_id);
	}

	rcvAddCalendar(response) {
		if (response.result != 'NG') {

			//Tommy - 24/06/2021
			if (this.props.receiver.app_model == 'H') this.props.receiver.next_component = 'Add_Edit_Schedule_Home';
			else this.props.receiver.next_component = 'Schedule_Step4_Execute_Days';

			let param = this.props.param;

			// Tommy - 24/06/2021 - Get the first key
			let cal_id = Object.keys(response)[0];

			if (isEmpty(param.program.action)) {
				param.program.action = {};
				param.program.action[this.props.param.pattern_id] = {};
			}
			param.program.action[this.props.param.pattern_id].exec_cal = [];
			param.program.action[this.props.param.pattern_id].exec_cal.push(cal_id);

			// Tommy - 24/06/2021 - For ReiriHome
			if (param.edit != null) {
				param.edit.selected_calendar_id = cal_id;
			}

			this.props.receiver.stored_params = param;
			this.props.receiver.getScene();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvModifyCalendar(response) {
		if (response.result == 'OK') {

			//Tommy - 24/06/2021
			if (this.props.receiver.app_model == 'H') this.props.receiver.next_component = 'Add_Edit_Schedule_Home';
			else this.props.receiver.next_component = 'Schedule_Step4_Execute_Days';

			let param = this.props.param;
			this.props.receiver.stored_params = param;
			this.props.receiver.getScene();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvDeleteCalendar(response) {
		if (response.result == 'OK') {

			//Tommy - 24/06/2021
			if (this.props.receiver.app_model == 'H') this.props.receiver.next_component = 'Add_Edit_Schedule_Home';
			else this.props.receiver.next_component = 'Schedule_Step4_Execute_Days';

			// Tommy - 24/06/2021 - For ReiriHome
			if (this.props.param.edit != null) {
				this.props.param.edit.selected_calendar_id = '';
			}

			this.props.receiver.stored_params = this.props.param;
			this.props.receiver.getScene();
		} else {
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let button_style = {
			width: this.props.width - 80,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
		}

		let cal_height = this.props.height - 305;
		if (cal_height < 200) cal_height = 200;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.calendar_id == '' ? this.props.receiver.getString('add_calendar') : this.props.receiver.getString('edit_calendar')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div style={{ width: this.props.width - 40, marginLeft: 10, marginTop: 20 }}>
						<Editbox id='calendar_name' style={{}} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangeCalendarName(event.target.value)} value={this.state.calendar_name} />
					</div>
					<div style={{ marginLeft: 20, marginTop: 20, }}>
						<CalendarWithMultiDates
							top={0}
							left={0}
							width={this.props.width - 40}
							height={cal_height}
							handleChangeDate={this.handleChangeDate}
							specified_dates={this.state.specified_dates}
							specified_by_week={this.state.specified_by_week}
							style={{ zIndex: 0, }}
							is_calendar_changed={true}
							receiver={this.props.receiver}
						/>
					</div>
				</div>
			</div>
		)
	}
}